<template>
  <v-app>
    <v-app-bar
      app
      color="white"
      height="100"
    >
      

      <v-toolbar-title class="d-none d-md-flex">
        <v-row>
          <v-col cols="12 mb-0 pb-0">
            <h2 class="font-weight-black">CIRCUITO DE PALESTRAS DE COMPUTAÇÃO</h2>
          </v-col>
          <v-col cols="12 pt-0 mt-0">
            <span class="text-md-subtitle-1 font-weight-bold"> IFRS - IBIRUBÁ/RS - 20 a 24/07/2020 e 27 a 31/07/2020</span>
          </v-col>
        </v-row>
         
      </v-toolbar-title>

      <v-toolbar-title class="d-flex d-sm-none d-none d-sm-flex d-md-none font-weight-black text-sm-body-1 headline">
        Circuito de Palestras<br>IFRS - Ibirubá
      </v-toolbar-title>
    
    
    
    </v-app-bar>

    <v-main>
      
      <v-sheet
        id="contact"
        color="#333333"
        dark
        tag="section"
        tile
      >
        <div class="py-12"></div>

        <v-container>
          <v-responsive class="mx-auto mb-12">
            <h4 class="text-md-h4 text-sm-body-2 text-lg-h4 font-weight-bold mb-3 text-uppercase text-center">Lista de Presenças por Usuário</h4>
            <h4 class="text-center">Em caso de problemas, enviar e-mail para: computacao@ibiruba.ifrs.edu.br</h4>
          </v-responsive>

          <v-responsive class="mx-auto mb-12">
            <v-alert
              outlined
              color="yellow"
              border="bottom"
            >
              <h3><v-icon color="yellow">mdi-information-outline</v-icon> Quanto tempo terei para assinar a presença?</h3>
              <h4>Caso você não possa assistir a palestra online, não se preocupe, você poderá assistir e assinar sua presença até <strong>07/08/2020</strong>.</h4>

            </v-alert>
          </v-responsive>

          <v-responsive
            class="mx-auto mb-12"
            width="56"
          >
            <v-divider class="mb-1"></v-divider>

            <v-divider></v-divider>
          </v-responsive>

              <v-row> 
                <v-col cols="12">
                    <v-autocomplete
                        v-model="usuario"
                        :items="usuarios"
                        label="Nome do Usuário"
                        item-text="nome"
                        item-value="email"
                        ></v-autocomplete>
                </v-col>
                
                <v-col cols="12">
                    <v-data-table
                        dense
                        :headers="headers"
                        :items="presencas"
                        :items-per-page="20"
                        class="elevation-1"
                        :search="usuario"
                        mobile-breakpoint="0"
                    >
                    
                    </v-data-table>
                </v-col>
            </v-row> 
        
        </v-container>

        <div class="py-12"></div>
      </v-sheet>
    </v-main>

    <v-footer
      class="justify-center"
      color="#292929"
      height="100"
    >
      <div class="title font-weight-light grey--text text--lighten-1 text-center">
        &copy; {{ (new Date()).getFullYear() }} — Computação - IFRS - Ibirubá
      </div>
    </v-footer>
  </v-app>
</template>

<script>
import moment from 'moment'

export default {
  name: 'App',

  data: () => ({
    search: '',
    headers: [
        
        { text: 'Palestra', value: 'palestraTitulo' },
        { text: 'E-mail', value: 'usuarioEmail' },
        { text: 'Data Assinatura', value: 'dataAssinatura' },
    ],
    
    presencas: [],
    presencasFiltradas: [],
    comentarios: [],
    usuario: '', 
    usuarios: [],
  }),

  async created() {
      try{
          this.$http.get('usuarios.json').then(
                res => {
                    for (const [key, value] of Object.entries(res.data)) {
                      var existe = false

                      for(var i=0; i< this.usuarios.length; i++){
                        var usuario = this.usuarios[i]
                        if(usuario.email == value.email){
                          existe = true
                        }
                      }
                      
                      if( existe == false ){
                        this.usuarios.push(
                          {
                              nome: value.nome.toUpperCase(),
                              email: value.email.toLowerCase(),
                              origem: value.origem,
                              cpf: value.cpf,
                              key: key
                          }
                        )
                      }
  
                    }
                    
                    this.ordenarNomes()
                }
            )
          
          this.$http.get('presenca.json').then(
                res => {
                    for (const [key, value] of Object.entries(res.data)) {
                        this.presencas.push(
                          {
                              usuarioEmail: value.usuarioEmail.toLowerCase(),
                              palestraTitulo: value.palestraTitulo,
                              palestraComentario: value.palestraComentario,
                              dataAssinatura: moment(value.dataAssinatura).format('DD/MM/YYYY hh:mm:ss'),
                              palestraRatingPalestra: value.palestraRatingPalestra,
                              palestraRatingTransmissao: value.palestraRatingTransmissao,
                              palestraRatingDuracao: value.palestraRatingDuracao,
                              palestraId: value.palestraId,
                              usuarioIp: value.usuarioIp,
                              key: key
                          }
                        )
                    }
                }
           )
      }catch(e){
          console.log("Houve erro: " + e)
      }
  },

  methods: {
    selecionaPalestra(){
          console.log("Palestra selecionada: " + this.palestra)
          let teste = this.presencas.filter( (presenca) => {
              return presenca.palestraId == this.palestra
          })
          this.presencasFiltradas = teste
    },

    ordenarNomes(){
        console.log("chamando ordenarnomes")
        this.usuarios.sort(function(a, b){
            var nameA=a.nome.toLowerCase(), nameB=b.nome.toLowerCase()
            if (nameA < nameB) //sort string ascending
                return -1 
            if (nameA > nameB)
                return 1
                return 0 //default return value (no sorting)
            })
    }

  }
};
</script>
